import React from 'react';
import type { FC } from 'react';
import { Box, Text } from '@wix/cli-ui-kit';

export const WelcomeMessage: FC = () => {
  return (
    <Box flexDirection="column" marginBottom={1} paddingTop={1}>
      <Text bold>Create Headless Site</Text>
    </Box>
  );
};
